import React from 'react';
import { useTheme } from '@mui/material';
import { QButton } from '@kubiq-base/core';
import { Link } from 'react-router-dom';

interface Props {
  children?: string | React.ReactElement;
  style?: React.CSSProperties;
  type?: 'reset' | 'submit';
  to?: { pathname: string; state?: Record<string, unknown> } | string;
  [propName: string]: unknown;
}

const CenteredQButton = ({ children, style, type, to, ...rest }: Props): JSX.Element => {
  const theme = useTheme();

  return (
    <div style={{ display: 'flex', justifyContent: 'center', width: '100%', minWidth: 250 }}>
      <QButton
        {...(to &&
          (typeof to === 'string'
            ? { component: Link, to: to }
            : { component: Link, to: to.pathname, state: to.state }))}
        type={type}
        style={{ ...style, marginTop: theme.spacing(1) }}
        {...rest}
      >
        {children}
      </QButton>
    </div>
  );
};

export default CenteredQButton;
